import { render, staticRenderFns } from "./EntertainmentAdd.vue?vue&type=template&id=33c3e5c2"
import script from "./EntertainmentAdd.vue?vue&type=script&lang=js"
export * from "./EntertainmentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports